import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { VehicleDataRow } from "./subcomponents";

export const VehicleHardwareDetails = ({ vehicle }) => {
  const { t } = useTranslation();

  return (
    <Grid>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.ScooterType")}>
        {vehicle?.scooter_type || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.SerialNumber")}>
        {vehicle?.serial_number || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.FIN")}>
        {vehicle?.fin || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.SystemController")}>
        {vehicle?.components?.find((component) => component.component_type === "systemcontroller")
          ?.serial_number || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.MotorDrive")}>
        {vehicle?.components?.find((component) => component.component_type === "motorcontroller")
          ?.serial_number || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.HardwareDetails.Battery")}>
        {vehicle?.components?.find((component) => component.component_type === "battery")
          ?.serial_number || ""}
      </VehicleDataRow>
    </Grid>
  );
};

VehicleHardwareDetails.propTypes = {
  vehicle: PropTypes.object.isRequired,
};

export default VehicleHardwareDetails;
